import React, { useState } from "react";
import "./TailorMadeForm.css";

const TailorMadeForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_code: "+20",
    phone_number: "",
    start_date: "",
    end_date: "",
    adults: 0,
    children: 0,
    children_age_range: "",
    wish_to_go: "",
    accommodation: "",
    nationality: "",
    notes: "",
    hear_about_us: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://orangered-hornet-549881.hostingersite.com/api/tailor-made-requests", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      console.log("Response:", data);

      if (res.ok) {
        alert("✅ Inquiry sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone_code: "+20",
          phone_number: "",
          start_date: "",
          end_date: "",
          adults: 0,
          children: 0,
          children_age_range: "",
          wish_to_go: "",
          accommodation: "",
          nationality: "",
          notes: "",
          hear_about_us: "",
        });
      } else {
        alert("❌ Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("❌ Failed to send inquiry!");
    }
  };

  return (
    <section className="AboutUsContent">
      <div className="container mx-auto px-4">
        <h2 className="form-title">Tailor-Made Your Tour</h2>

        <form className="grid gap-4" onSubmit={handleSubmit}>
          {/* Name & Email */}
          <div className="grid md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name*"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-input modern"
            />
            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-input modern"
            />
          </div>

          {/* Dates */}
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1 font-medium">Start Date</label>
              <input
                type="date"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                className="form-input modern"
              />
            </div>
            <div>
              <label className="block text-sm mb-1 font-medium">End Date</label>
              <input
                type="date"
                name="end_date"
                value={formData.end_date}
                onChange={handleChange}
                className="form-input modern"
              />
            </div>
          </div>

          {/* Phone */}
          <div className="grid md:grid-cols-2 gap-4">
            <select
              name="phone_code"
              value={formData.phone_code}
              onChange={handleChange}
              className="form-input modern"
            >
              <option value="+1">USA (+1)</option>
              <option value="+20">Egypt (+20)</option>
              <option value="+44">UK (+44)</option>
            </select>
            <input
              type="text"
              name="phone_number"
              placeholder="Phone Number"
              value={formData.phone_number}
              onChange={handleChange}
              className="form-input modern"
            />
          </div>

          {/* Adults & Children */}
          <div className="grid md:grid-cols-2 gap-4">
            <div className="counter-box">
              <span>Adults</span>
              <div className="counter-controls">
                <button
                  type="button"
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      adults: prev.adults > 0 ? prev.adults - 1 : 0,
                    }))
                  }
                >
                  -
                </button>
                <span>{formData.adults}</span>
                <button
                  type="button"
                  onClick={() =>
                    setFormData((prev) => ({ ...prev, adults: prev.adults + 1 }))
                  }
                >
                  +
                </button>
              </div>
            </div>

            <div className="counter-box">
              <span>Children</span>
              <div className="counter-controls">
                <button
                  type="button"
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      children: prev.children > 0 ? prev.children - 1 : 0,
                    }))
                  }
                >
                  -
                </button>
                <span>{formData.children}</span>
                <button
                  type="button"
                  onClick={() =>
                    setFormData((prev) => ({ ...prev, children: prev.children + 1 }))
                  }
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* Wish & Accommodation */}
          <div className="grid md:grid-cols-2 gap-4">
            <select
              name="wish_to_go"
              value={formData.wish_to_go}
              onChange={handleChange}
              className="form-input modern"
            >
              <option value="">Where You Wish to Go</option>
              <option value="Cairo">Cairo</option>
              <option value="Luxor">Luxor</option>
              <option value="Aswan">Aswan</option>
            </select>
            <select
              name="accommodation"
              value={formData.accommodation}
              onChange={handleChange}
              className="form-input modern"
            >
              <option value="">Accommodation Choices</option>
              <option value="Hotel">Hotel</option>
              <option value="Resort">Resort</option>
              <option value="Apartment">Apartment</option>
            </select>
          </div>

          {/* Nationality & Children Ages */}
          <div className="grid md:grid-cols-2 gap-4">
            <select
              name="nationality"
              value={formData.nationality}
              onChange={handleChange}
              className="form-input modern"
            >
              <option value="">-- Nationality --</option>
              <option value="Egypt">Egypt</option>
              <option value="USA">USA</option>
              <option value="UK">UK</option>
            </select>
            <select
              name="children_age_range"
              value={formData.children_age_range}
              onChange={handleChange}
              className="form-input modern"
            >
              <option value="">Children Ages Range</option>
              <option value="0-2">0 - 2</option>
              <option value="3-6">3 - 6</option>
              <option value="7-12">7 - 12</option>
            </select>
          </div>

          {/* Notes */}
          <textarea
            name="notes"
            placeholder="Extra Note"
            value={formData.notes}
            onChange={handleChange}
            className="form-input-text-area modern w-full"
          ></textarea>

          {/* How did you hear */}
          <div className="w-full">
            <p className="font-semibold mb-3">How Did You Hear About Us?</p>
            <div className="hear-options flex flex-wrap gap-4">
              {["Search Engine", "Social Media", "TripAdvisor", "A Friend"].map(
                (option) => (
                  <label key={option}>
                    <input
                      type="radio"
                      name="hear_about_us"
                      value={option}
                      checked={formData.hear_about_us === option}
                      onChange={handleChange}
                    />{" "}
                    {option}
                  </label>
                )
              )}
            </div>
          </div>

          {/* Submit */}
          <div className="text-center">
            <button type="submit" className="submit-btn">
              Send an Inquiry
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default TailorMadeForm;
